// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_QvT","cls2":"PaperBrowserPreviewList-cls2_pUt PaperBrowserPreviewList-cls1_QvT"};